import { Box, Group } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import type { ReactNode } from "react";

/**
 * Desktop detail layout: the work in the main column, context on the right.
 *
 * The split is not arbitrary. The main column holds what the person is
 * DOING - stage, notes, the action - and the rail holds what they need to
 * KNOW while doing it: who the customer is, what the battery is, the history.
 * Putting context in the rail is what stops the main column becoming a wall.
 *
 * Below lg the rail stops being a rail and falls underneath, because a 360px
 * column beside a 360px column is two unreadable columns.
 */
export function RecordWithRail({
  main,
  rail,
  railWidth = 360,
}: {
  main: ReactNode;
  rail: ReactNode;
  railWidth?: number;
}) {
  const wide = useMediaQuery("(min-width: 75em)");

  if (!wide) {
    return (
      <Box>
        {main}
        <Box mt="lg">{rail}</Box>
      </Box>
    );
  }

  return (
    <Group align="flex-start" gap="xl" wrap="nowrap">
      <Box style={{ flex: 1, minWidth: 0 }}>{main}</Box>
      <Box style={{ width: railWidth, flexShrink: 0 }}>{rail}</Box>
    </Group>
  );
}
